<template>
  <div>
    <order-channel-type-form v-model="order_channel_type" v-if="this.order_channel_type"></order-channel-type-form>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      order_channel_type: null
    };
  },
  mounted: function () {
    Api.find('order_channel_types', this.order_channel_type_id)
      .then(({ data }) => {
        this.order_channel_type = data;
      })
      .catch(function () {
        console.error('Failed loading order channel');
      });
  },
  props: ['order_channel_type_id']
};
</script>
